module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[113]600.25dbbd4.woff2";